import { useMemo } from 'react';
import { useGetAllAssetConfigurationsQuery } from '../../../__generated__/chirp/com/hubspot/studio/backend/rpc/assetconfiguration/AssetConfigurationService.hooks';
import { transformRpcResponseToFAS } from 'campaigns-utils-lib/campaignsAssociations';
import { useFetchAssociationDefinition } from './useFetchAssociationDefinition';
import { getAssetObjectTypeId, getIsAssetUngatedForOneToMany } from 'campaigns-lib/utils/campaignGates';
export function useAssetConfiguration(objectType) {
  var _objectDefinition$nam, _objectDefinition$obj;
  const {
    data: assetConfigurationsData
  } = useGetAllAssetConfigurationsQuery();
  const associationSettings = useMemo(() => assetConfigurationsData ? transformRpcResponseToFAS(assetConfigurationsData) : undefined, [assetConfigurationsData]);
  const objectDefinition = useMemo(() => {
    var _assetConfigurationsD;
    return assetConfigurationsData === null || assetConfigurationsData === void 0 || (_assetConfigurationsD = assetConfigurationsData.objectPropertyDefinitions) === null || _assetConfigurationsD === void 0 ? void 0 : _assetConfigurationsD.find(def => def.name === objectType || def.objectTypeId === objectType);
  }, [assetConfigurationsData === null || assetConfigurationsData === void 0 ? void 0 : assetConfigurationsData.objectPropertyDefinitions, objectType]);
  const resolvedObjectType = (_objectDefinition$nam = objectDefinition === null || objectDefinition === void 0 ? void 0 : objectDefinition.name) !== null && _objectDefinition$nam !== void 0 ? _objectDefinition$nam : objectType;
  const resolvedObjectTypeId = (_objectDefinition$obj = objectDefinition === null || objectDefinition === void 0 ? void 0 : objectDefinition.objectTypeId) !== null && _objectDefinition$obj !== void 0 ? _objectDefinition$obj : getAssetObjectTypeId(objectType);
  const {
    data: associationDefinition,
    loading: associationDefinitionLoading
  } = useFetchAssociationDefinition({
    associationSettings,
    objectType: resolvedObjectType
  });
  const isOneToMany = useMemo(() => (associationDefinition === null || associationDefinition === void 0 ? void 0 : associationDefinition.cardinality) === 'ONE_TO_MANY' && getIsAssetUngatedForOneToMany(objectType), [associationDefinition === null || associationDefinition === void 0 ? void 0 : associationDefinition.cardinality, objectType]);
  return {
    associationSettings,
    objectDefinition,
    resolvedObjectType,
    resolvedObjectTypeId,
    isOneToMany,
    loadingAssociationDefinition: associationDefinitionLoading
  };
}